import React from 'react';
import { AlertRounded } from '../../shared/icons';
import styles from './ErrorBanner.module.scss';

type ErrorBannerProps = {
    errorText: string;
    errorComponent?: React.ReactElement;
};
export const ErrorBanner: React.FC<ErrorBannerProps> = ({
    errorText,
    errorComponent,
}) => {
    return (
        <div className={styles.ErrorBanner}>
            <div>
                <AlertRounded className={styles.Icon} />
            </div>
            {errorComponent || <p>{errorText}</p>}
        </div>
    );
};
